// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-tab[data-v-06697248]{transition:all .2s ease-in-out;cursor:pointer;padding:1rem}@media(prefers-reduced-motion:reduce){.v-tab[data-v-06697248]{transition:none}}.v-tab--active[data-v-06697248],.v-tab[data-v-06697248]:hover{color:#3670ff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
